
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZModal',
  props: {
    title: {
      type: String,
      default: undefined
    },
    body: {
      type: String,
      default: undefined
    },
    width: {
      type: String,
      default: 'base',
      validator: (value: string) => {
        return ['narrow', 'base', 'wide', 'extra-wide'].includes(value)
      }
    },
    closeAfterPrimaryAction: {
      type: Boolean,
      default: true
    },
    primaryActionLabel: {
      type: String,
      default: undefined
    },
    primaryActionIcon: {
      type: String,
      default: undefined
    },
    primaryActionType: {
      type: String,
      default: 'primary'
    },
    showHeaderBorder: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    preventClose: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal(): void {
      this.$emit('onClose')
    },
    primaryAction(close: () => void): void {
      this.$emit('primaryAction')
      if (this.closeAfterPrimaryAction) {
        close()
      }
    }
  }
})
